export default {
  priv: 'pr_device',
  overviewTitle: 'Layout Export',
  detailTitle: 'Layout Export',
  deleteTitle: 'deze layout',
  url: '/devices/exportlayouts',
  apiUrl: '/devicereportlayouts/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'exportlayouts',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  newRecord: {
    report_layout_type: 1
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/devices/exportlayouts/{id}',
      width: '30%'
    },
    {
      text: 'Bestandsnaam',
      value: 'file.name',
      width: '30%'
    },
    {
      text: 'Grootte',
      value: 'file.size',
      width: '20%',
      filter: 'prettyBytes'
    }
  ]
};
